import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { isEmpty } from 'lodash'
import Card from './Card'
import Heading from './Heading'
import List, { ListItem } from './List'

export interface ItemsCardItem {
  code: string
  description: string
  remainingQuantity: number
}

interface ItemsCardProps {
  items: ItemsCardItem[]
}

export default class ItemsCard extends Component<ItemsCardProps> {
  data (item: ItemsCardItem): ListItem[] {
    return [
      { key: 'Code', value: item.code, highlight: false },
      { key: 'Description', value: item.description, highlight: false },
      { key: 'Remaining quantity', value: item.remainingQuantity, highlight: true }
    ]
  }

  item (item: ItemsCardItem) {
    return (
      <div
        className="mb-4 last:mb-0"
        key={item.code}>
        <List items={this.data(item)} />
      </div>
    )
  }

  get items () {
    return this.props.items.map(item => this.item(item))
  }

  render () {
    const hasItems = !isEmpty(this.props.items)
    return hasItems && (
      <Card>
        <Heading
          className="mb-2"
          text={i18n("Items")} />
        {this.items}
      </Card>
    )
  }
}
